import { CModal } from "./CModal";
import { ModalDelete } from "./ModalDelete";
import { ModalFilterUser } from "./ModalFilterUser";

export {
    CModal ,
    ModalDelete ,
    ModalFilterUser ,
}